"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreAsync = void 0;
const store_1 = require("./store");
class StoreAsync {
    constructor(options) {
        this.storage = new store_1.Store(options);
    }
    setItem(key, value) {
        try {
            this.storage.setItem(key, value);
            return Promise.resolve();
        }
        catch (_a) {
            return Promise.reject();
        }
    }
    getItem(key) {
        try {
            const result = this.storage.getItem(key);
            return Promise.resolve(result);
        }
        catch (_a) {
            return Promise.reject();
        }
    }
    removeItem(key) {
        try {
            this.storage.removeItem(key);
            return Promise.resolve();
        }
        catch (_a) {
            return Promise.reject();
        }
    }
    clear() {
        try {
            this.storage.clear();
            return Promise.resolve();
        }
        catch (_a) {
            return Promise.reject();
        }
    }
}
exports.StoreAsync = StoreAsync;
//# sourceMappingURL=storeAsync.js.map